import * as React from 'react';
import { useEffect, useState } from 'react';

import { useRetracked } from 'js/lib/retracked';
import { useLocation } from 'js/lib/useRouter';

import { Search } from '@coursera/cds-core';

import { useSearch } from 'bundles/search-common/providers/SearchContext';

import _t from 'i18n!nls/coursera-plus-landing-page';

type Props = {
  currentSearchQuery: string;
  placeholderText?: string;
  searchInputLabelId?: string;
};

const SearchBar = ({ currentSearchQuery, placeholderText, searchInputLabelId }: Props) => {
  const [searchText, setSearchText] = useState(currentSearchQuery || '');
  const location = useLocation();
  const track = useRetracked();
  const { updateQuery } = useSearch();

  useEffect(() => {
    setSearchText(currentSearchQuery || '');
  }, [currentSearchQuery]);

  const submitHandler = () => {
    updateQuery(searchText);

    track({
      trackingData: { searchText, page: location.pathname },
      trackingName: 'coursera_plus_searchbar',
      action: 'search',
    });
  };

  return (
    <Search
      fullWidth
      value={searchText}
      onChange={(value) => setSearchText(value)}
      onSearch={submitHandler}
      aria-labelledby={searchInputLabelId}
      placeholder={placeholderText ?? _t('e.g. Machine Learning')}
    />
  );
};

export default SearchBar;
